import {Space, Upload, Image, Spin} from 'antd';
import styles from './index.module.scss';
import {LinkButton} from '../../Buttons/LinkButton';
import {DeleteOutlined, EyeOutlined} from '@ant-design/icons';
import {useState} from 'react';
import useRequestFn from '../../../Utils/Hooks/useRequestFn';
import {uploadToQiNiu} from '../../../Services/common';
import {UploadChangeParam, UploadFile} from 'antd/lib/upload/interface';
import classNames from 'classnames';
import {UploadProps} from 'antd/es';

interface UploadSinglePhotoProps
    extends Omit<UploadProps, 'value' | 'onChange'> {
    value?: string;
    onChange?(value?: string): void;
}

export function UploadSinglePhoto({
    value,
    className,
    onChange,
    ...props
}: UploadSinglePhotoProps) {
    const [preview, setPreview] = useState(false);

    const [onUpload, {loading}] = useRequestFn(
        async (info: UploadChangeParam<UploadFile<any>>) => {
            const data = await uploadToQiNiu(info.file as unknown as File);
            onChange?.(data.url);
        },
    );

    function beforeUpload() {
        return false;
    }

    function onDelete() {
        onChange?.(undefined);
    }

    const SelectButton = (
        <div className={styles.button}>
            {loading && <Spin />}
            {!loading && <span>+ 选择图片</span>}
        </div>
    );

    const PhotoItem = (
        <div className={styles.photo}>
            <img src={value} alt="" />

            <Space className={styles.tools}>
                <LinkButton
                    icon={<EyeOutlined />}
                    onClick={() => setPreview(true)}
                />

                <LinkButton icon={<DeleteOutlined />} onClick={onDelete} />
            </Space>

            <Image
                style={{display: 'none'}}
                preview={{
                    visible: preview,
                    src: value,
                    onVisibleChange: value => {
                        setPreview(value);
                    },
                }}
            />
        </div>
    );

    return (
        <Upload
            disabled={!!value}
            className={classNames(styles.root, className)}
            showUploadList={false}
            beforeUpload={beforeUpload}
            onChange={onUpload}
            accept="image/*"
            {...props}>
            {value ? PhotoItem : SelectButton}
        </Upload>
    );
}
